import type { TTheme } from './models';

export const DEFAULT_THEME: TTheme = 'white';

export const MARGIN = 45;

/** Время инициализации табов, навешивания listeners */
export const INIT_TIME = 350;

export const ANIMATION_DURATION_MS = 200;
